import React from 'react';
import { ProductAmount } from 'types/ProductData';
import { useIntl } from 'react-intl';

interface WholesaleInfoProps {
  productAmount?: ProductAmount;
}

const WholesaleInfo = ({ productAmount }: WholesaleInfoProps) => {
  const intl = useIntl();

  const hasWholesalePrice = !!(
    productAmount?.storage_wholesale_limit &&
    productAmount?.storage_wholesale_price &&
    productAmount?.storage_stock_price !== undefined &&
    productAmount.storage_wholesale_price < productAmount.storage_stock_price
  );
  const hasMinAmount = !!(
    productAmount?.storage_limit_min && productAmount.storage_limit_min > 1
  );

  if (!hasWholesalePrice && !hasMinAmount) return null;

  return (
    <div className={'wholesale-info'}>
      {productAmount?.storage_wholesale_limit &&
      productAmount?.storage_wholesale_price &&
      productAmount?.storage_stock_price !== undefined &&
      productAmount.storage_wholesale_price <
        productAmount.storage_stock_price ? (
        <div className={'wholesale'}>
          {intl.formatMessage({ id: 'wholesale.amount' })}
          {productAmount.storage_wholesale_limit} {productAmount.storage_unit}
          {intl.formatMessage({ id: 'wholesale.price' })}
          {productAmount.storage_wholesale_price}
          {intl.formatMessage({ id: 'wholesale.euro' })}
        </div>
      ) : null}
      {productAmount?.storage_limit_min &&
      productAmount.storage_limit_min > 1 ? (
        <div className={'storage_limit'}>
          {intl.formatMessage({ id: 'wholesale.min_amount' })}
          {productAmount.storage_limit_min} {productAmount?.storage_unit}
        </div>
      ) : null}
    </div>
  );
};

export default WholesaleInfo;
